import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';
import { type SimilarCards as SchemaSimilarCards } from '../schemas/SimilarCards';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags SimilarCards
 * @summary Получить настройки похожих карточек для карточки товара
 */
export const GetSimilarCardsContentType = '' as const;
export type GetSimilarCardsRequest = void;
export type GetSimilarCardsResponses = LinkCommonErrorResponses & {
    /**
     * @description Настройки найдены
     */
    '200': {
        'application/json': SchemaSimilarCards;
    };
    /**
     * @description Настройки не найдены
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type GetSimilarCardsResponseSuccess = GetSimilarCardsResponses['200']['application/json'];
export type GetSimilarCardsSearchParams = undefined;
export type GetSimilarCardsPathParameters = {
    card_id: string;
};
export const GetSimilarCardsUrl = '/cards/{card_id}/similar-cards' as const;
export const GetSimilarCardsMethod = 'GET' as const;
export const getGetSimilarCardsUrl = (params: GetSimilarCardsPathParameters) =>
    GetSimilarCardsUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetSimilarCardsPathParameters) =>
        String(params[param])
    );
